import React from "react";
import { BookOpenIcon, ClipboardListIcon, GiftIcon, HandshakeIcon, ImageIcon, MessageCircleIcon, PuzzleIcon, SchoolIcon, BoxIcon } from "lucide-react";
const icons: Record<string, BoxIcon> = {
  book: BookOpenIcon,
  gift: GiftIcon,
  puzzle: PuzzleIcon,
  clipboard: ClipboardListIcon,
  speech: MessageCircleIcon,
  school: SchoolIcon,
  handshake: HandshakeIcon,
  image: ImageIcon
};
type ContentIconProps = {
  name: string;
  className?: string;
};
export function ContentIcon({
  name,
  className
}: ContentIconProps) {
  const Icon = icons[name] ?? PuzzleIcon;
  return <Icon className={className} aria-hidden="true" data-id="element-19" data-mp="25c5gsus5y4ip" />;
}